// extracted by mini-css-extract-plugin
module.exports = {"container":"ua_container__R_CfK","primaryFaint":"ua_primaryFaint__34xZn"};